export type TNullable<T> = T | null;

export enum ESliceDataFetchingStatus {
  'loading' = 'LOADING',
  'initial' = 'INITIAL',
  'success' = 'SUCCESS',
  'error' = 'ERROR',
}
